import { Avatar, Button } from '@material-ui/core'
import { useSelector } from 'react-redux'
import CircularSpinner from '../circularSpinner'
import './button.scss'

const JButton = ({
  label,
  color,
  onClick,
  icon,
  disabled,
  classes,
  type,
  size,
  height,
  loading,
  isCorporate,
  id,
}) => {
  const {
    Mode,
    CustomerInfoData: {customerInfo},
  } = useSelector((state) => state)
  return (
    <Button
      id={id}
      variant="contained"
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      startIcon={
        icon ? (
          <Avatar className="avatar-container" src={icon} alt={label} />
        ) : null
      }
      className={`button-container ${
        color === 'primary' || 'JawwalPayButton' || 'main'
          ? `${color} ${color}-${Mode.selectedMode}`
          : `${color}-${Mode.selectedMode}`
      } ${classes}-button ${
        disabled &&
        (color === 'primary' ||
          'JawwalPayButton' ||
          'jawwalAppButton' ||
          'main')
          ? 'label-container-disabled'
          : null
      } button-${size ? `${size}` : `md`} button-${height ? `${height}` : ''} 
       ${loading ? 'button-container-loading' : ''} ${
        isCorporate ? 'button-corporate' : ''
      }` }>
      {loading ? <CircularSpinner size={20} /> : label}
    </Button>
  )
}

export default JButton
